import { AccessorsMutatorsDecorator, Model } from "../../helpers";

export class ReservationActivity extends Model {
    
}

AccessorsMutatorsDecorator('id', 'description', 'subject_id', 'causer_id', 'causer', 'causer_name', 'properties', 'created_at', 'updated_at', 'property_id', 'property', 'description_extend')(ReservationActivity);


// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-activity.model.js